export const START_COUNTDOWN = 'START_COUNTDOWN';
export const PAUSE_COUNTDOWN = 'PAUSE_COUNTDOWN';
